/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-vars */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import parse from 'html-react-parser';
import axios from 'axios';
import { escape } from 'lodash';
import { isMobile } from 'react-device-detect';

class RollingBannerItem extends Component {
  state = {
    width: 0,
  };

  componentDidMount = () => {
    this.setState({
      width: window.innerWidth,
    });
  };
  _onBannerClick = async () => {
    const {
      Linktarget,
      LinkURL,
      Linktarget_M,
      LinkURL_M,
      idx,
      adComIdx,
      pageCode,
    } = this.props.childProps;
    const { history, setEventIdx } = this.props;
    if (adComIdx !== 1) {
      const result = await this._bannerClickApi(idx, adComIdx, pageCode);
      const intReturn = result.data[0].intReturn;
    }
    //console.log(idx)
    //console.log(comment)

    /*
        if(LinkURL.indexOf('https') > -1) {
            window.open(LinkURL, '', '')
        } else {
            if (Linktarget === '_blank'){
                window.open(LinkURL, '', '')
            } else {
                history.push('/event/' + LinkURL)
            }
        }
        */
    if (
      idx === 79 ||
      idx === 80 ||
      idx === 81 ||
      idx === 101 ||
      idx === 104 ||
      idx === 127 ||
      idx === 129
    ) {
      if (idx === 127 || idx === 129) {
        if (isMobile) {
          history.push('/event/' + LinkURL_M);
        } else {
          history.push('/event/' + LinkURL);
        }
      } else {
        if (isMobile) {
          setEventIdx(parseInt(LinkURL_M), 3);
        } else {
          setEventIdx(parseInt(LinkURL), 3);
        }
      }
    } else {
      //console.log(isMobile, Linktarget_M, LinkURL_M);
      if (isMobile) {
        if (Linktarget_M === '_blank') {
          window.open(LinkURL_M, '', '');
        } else {
          history.push(LinkURL_M);
        }
      } else {
        if (Linktarget === '_blank') {
          window.open(LinkURL, '', '');
        } else {
          history.push(LinkURL);
        }
      }
    }
  };
  _bannerClickApi = (idx, adComIdx, pageCode) => {
    const { apiUrl, loginId } = this.props;

    return axios.post(apiUrl + '/bannerClick', {
      params: {
        userid: loginId,
        idx: idx,
        adComIdx: adComIdx,
        pageCode: pageCode,
      },
    });
  };
  _isTab = () => {
    const { userAgent, maxTouchPoints } = window.navigator;

    const isMac = /Macintosh/i.test(userAgent);

    if (isMac && maxTouchPoints > 0) return true;

    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi|mobi/i.test(
      userAgent
    );
  };
  render() {
    const { width } = this.state;
    const { bannerFile, LinkURL, Linktarget, title, comment } =
      this.props.childProps;
    const { fileUrl } = this.props;
    const isTab = this._isTab();
    return (
      <Fragment>
        <div
          className="div_li"
          style={width < 1024 ? { marginLeft: 150, width: '100%' } : {}}
        >
          <div className="obg">
            <div className="bg_img" onClick={this._onBannerClick}>
              <img src={fileUrl + '/banner/' + bannerFile} />
            </div>
          </div>
          <div className="text_group">
            <h1
              onClick={this._onBannerClick}
              style={isMobile ? { fontSize: 12 } : {}}
            >
              {parse(comment)}
              {/*<em>6월18일 오픈!</em>*/}
            </h1>
            <span>{title}</span>
          </div>
        </div>

        {/*
                <div onClick={this._onClick}>
                    <img src = {'https://bc8azosk4j.ecn.cdn.ofs.kr/aniplustv/banner/' + bannerFile} />
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(RollingBannerItem));
